import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { fifteenMinuteOptions, thirtyMinuteOptions, hourlyOptions } from './minute-schedule-config.constants';

export type frequencyType = 'every_15_minutes' | 'every_30_minutes' | 'hourly';

@Component({
  standalone: true,
  imports: [CommonModule, MatLegacySelectModule],
  selector: 'mode-minute-schedule-config',
  templateUrl: './minute-schedule-config.component.html',
  styleUrls: ['./minute-schedule-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinuteScheduleConfigComponent {
  @Input() frequencyType: frequencyType = 'every_15_minutes';
  @Input() startTimeSelected = 0;
  @Output() startTimeChanged = new EventEmitter<number>();
  public options = {
    every_15_minutes: fifteenMinuteOptions,
    every_30_minutes: thirtyMinuteOptions,
    hourly: hourlyOptions,
  };
}
